var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-layout',{attrs:{"fluid":""}},[_c('v-container',{attrs:{"fluid":""}},[_c('v-layout',[_c('v-flex',{attrs:{"md12":"","lg10":"","ma-auto":""}},[_c('declined-transactions-detail',{attrs:{"transactionId":_vm.transactionId}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }